import {useState} from "react";
import {useSelector} from "react-redux";

import {IOption} from "@pg-design/select-module";

import {IRPStore} from "../../app/rp_reducer";
import {timeOptions} from "../constants/time_options";
import {TransportLabels} from "../types/TransportLabels";
import {TravelTimeTransport} from "../types/TravelTimeTransport";

const transportOptions: IOption[] = [
    {label: TransportLabels.CAR, value: TravelTimeTransport.CAR},
    {label: TransportLabels.PUBLIC_TRANSPORT, value: TravelTimeTransport.PUBLIC_TRANSPORT}
];

export const useTravelTime = () => {
    const travelTime = useSelector((state: IRPStore) => state.search.travelTime);
    const initTransportOption = transportOptions.find((option) => option.value === travelTime.data.transport_type);
    const initTimeOption = timeOptions.find((option) => option.value === travelTime.data.travel_time);
    const [transportOption, setTransportOption] = useState<IOption>(initTransportOption || transportOptions[0]);
    const [timeOption, setTimeOption] = useState<IOption>(initTimeOption || timeOptions[0]);

    const handleTransportChange = (value: unknown) => {
        setTransportOption(value as IOption);
    };

    const handleTimeChange = (value: unknown) => {
        setTimeOption(value as IOption);
    };

    const reset = () => {
        setTransportOption(transportOptions[0]);
        setTimeOption(timeOptions[0]);
    };

    const transport = {
        label: "Środek transportu:",
        options: transportOptions,
        active: transportOption,
        onChange: handleTransportChange
    };

    const time = {
        label: "Czas dojazdu:",
        options: timeOptions,
        active: timeOption,
        onChange: handleTimeChange
    };

    return {
        transport,
        time,
        resetFields: reset
    };
};
import {useState} from "react";
import {useSelector} from "react-redux";

import {IOption} from "@pg-design/select-module";

import {IRPStore} from "../../app/rp_reducer";
import {timeOptions} from "../constants/time_options";
import {TransportLabels} from "../types/TransportLabels";
import {TravelTimeTransport} from "../types/TravelTimeTransport";

const transportOptions: IOption[] = [
    {label: TransportLabels.CAR, value: TravelTimeTransport.CAR},
    {label: TransportLabels.PUBLIC_TRANSPORT, value: TravelTimeTransport.PUBLIC_TRANSPORT}
];

export const useTravelTime = () => {
    const travelTime = useSelector((state: IRPStore) => state.search.travelTime);
    const initTransportOption = transportOptions.find((option) => option.value === travelTime.data.transport_type);
    const initTimeOption = timeOptions.find((option) => option.value === travelTime.data.travel_time);
    const [transportOption, setTransportOption] = useState<IOption>(initTransportOption || transportOptions[0]);
    const [timeOption, setTimeOption] = useState<IOption>(initTimeOption || timeOptions[0]);

    const handleTransportChange = (value: unknown) => {
        setTransportOption(value as IOption);
    };

    const handleTimeChange = (value: unknown) => {
        setTimeOption(value as IOption);
    };

    const reset = () => {
        setTransportOption(transportOptions[0]);
        setTimeOption(timeOptions[0]);
    };

    const transport = {
        label: "Środek transportu:",
        options: transportOptions,
        active: transportOption,
        onChange: handleTransportChange
    };

    const time = {
        label: "Czas dojazdu:",
        options: timeOptions,
        active: timeOption,
        onChange: handleTimeChange
    };

    return {
        transport,
        time,
        resetFields: reset
    };
};
